module.exports = __webpack_public_path__ + "7867d31daa065fc809baa719ea18320d.png";